import { useEffect, useState } from 'react';

const CountdownTimer = ({ timeMs, startTimer, onExpire }) => {
    const [remainingTime, setRemainingTime] = useState(timeMs);
    const [expired, setExpired] = useState(false);

    useEffect(() => {
        setRemainingTime(timeMs);
        setExpired(false);
    }, [timeMs]);


    useEffect(() => {
        if (!startTimer || expired) return;

        const interval = setInterval(() => {
        setRemainingTime((prev) => {
            if (prev <= 1000) {
            clearInterval(interval);
            setExpired(true);
            return 0;
            }
            return prev - 1000;
        });
        }, 1000);

        return () => clearInterval(interval);
    }, [startTimer, expired]);

    useEffect(() => {
        if (expired) {
        onExpire(true);
        }
    }, [expired, onExpire]);

    const formatTime = (ms) => {
        const minutes = Math.floor(ms / 60000);
        const seconds = Math.floor((ms % 60000) / 1000);
        return `${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`;
    };

    const danger = remainingTime <= 60000;

    return (
        <div className={`timer-container ${danger ? 'danger' : ''}`}>
            <h4 className="timer-display">{formatTime(remainingTime)}</h4>
        </div>
    );
};

export default CountdownTimer;
